import { render } from "./TheMobileHeader.vue?vue&type=template&id=4929b037&scoped=true"
import script from "./TheMobileHeader.vue?vue&type=script&lang=js"
export * from "./TheMobileHeader.vue?vue&type=script&lang=js"

import "./TheMobileHeader.vue?vue&type=style&index=0&id=4929b037&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4929b037"]])

export default __exports__